module.exports = __webpack_public_path__ + "fonts/Inter-800-greek56.3a3cf1a.woff2";